import { HowSellValidation, RucaAndSisa } from '@shared-logic/integration-ibm';
import {
  OrderString,
  PurchaseMethodValidationState,
  PURCHASE_METHOD_GATE_PENDING,
  ValidationStruct,
} from '../interfaces/order.interface';
import { initialPriceString } from './prices.const';

export const orderTags = {
  price: 'price',
  name: 'name',
  placeOfOrigin: 'placeOfOrigin',
  town: 'town',
  province: 'province',
  afip: 'afip',
  broke: 'broke',
  howSell: 'howSell',
  buyer: 'buyer',
  onlySell: 'onlySell',
  notSell: 'notSell',
  tons: 'tons',
  statusOrder: 'statusOrder',
  quotas: 'quotas',
  orderDestination: 'orderDestination',
  orderOrigin: 'orderOrigin',
  orderType: 'orderType',
  orderCategory: 'orderCategory',
  commision: 'commision',
  comissionSeller: 'seller',
  comissionBuyer: 'buyer',
  message: 'message',
  nameOfcreator: 'nameOfcreator',
  dateOfcreation: 'dateOfcreation',
  dataOfCreation: 'dataOfcreation',
  sellerName: 'sellerName',
  sellerData: 'sellerData',
  observationsParameterized: 'obsParam',
  codeS: 'codeS',
  sucG: 'sucG',
  cuit: 'cuit',
  buyerCode: 'buyerCode',
  hour: 'hour',
};

export const initialOrderString: OrderString = {
  price: initialPriceString,
  hour: '',
  orderOrigin: [],
  statusOrder: [],
  tons: {
    end: 0,
    start: 0,
  },
  buyer: [],
  codeS: [],
  nroTeam: [],
  nameOfcreator: [],
  broke: [],
};

export const validationInitialState: ValidationStruct = {
  isExchanger: false,
  isCompleted: false,
  sellerCode: 0,
};

export const rucaAndSisaInitialState: RucaAndSisa = {
  'COD.ACTIVIDAD RUCA': '',
  'COD.ACTIVIDAD SISA': '',
  'Estado SISA': 0,
  'Producción Propia': '',
  ExisteRuca: '',
  ExisteSisa: '',
  Vendedor: '',
};

export const howSellValidationInitialState: HowSellValidation = {
  ComoVende: '',
  Validación: '',
  Vendedor: '',
};

/* No combination has been checked yet, so there is nothing a verdict could authorise.
Pending is the safe starting point: the gate blocks until a real answer arrives. */
export const purchaseMethodValidationInitialState: PurchaseMethodValidationState = {
  pair: null,
  status: PURCHASE_METHOD_GATE_PENDING,
};
